import { ROOTPATH } from '../config';
import send from './send';

//获取认证
const ossUploader = {
  uploadParam: {},
  init() {
    this.getOssParam();
  },
  getOssParam() {
    if (Object.keys(this.uploadParam).length > 0) {
      return;
    }
    return new Promise((resolve, reject) => {
      send({
        url: `${ROOTPATH}/app/aliyun/oss-policy`,
        method: 'POST',
      }).then((res) => {
        if (res.data.error === 0) {
          let { data } = res.data;
          this.uploadParam = {
            policy: data['policy'],
            OSSAccessKeyId: data['accessid'],
            success_action_status: 200,
            signature: data['signature'],
            dir: data['prefixPath'],
            host: data['host'],
          };
          resolve();
        } else {
          reject();
        }
      });
    });
  },
  getCode() {
    function random(m, n) {
      var num = Math.floor(Math.random() * (m - n) + n);
      return num;
    }
    let str = '';
    for (var i = 0; i < 10; i++) {
      var k = random(10, 100);
      str += k;
    }
    return str;
  },
  randomString(len) {
    len = len || 32;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  getSuffix(filename) {
    let pos = filename.lastIndexOf('.');
    let suffix = '';
    if (pos != -1) {
      suffix = filename.substring(pos);
    }
    return suffix;
  },
  async upload(file, onSuccess, onError, onProgress=()=>{}) {
    await this.getOssParam();
    const formData = new FormData();
    Object.keys(this.uploadParam).forEach((key) => {
      formData.append(key, this.uploadParam[key]);
    });
    const { name } = file;
    const key =
      this.uploadParam.dir +
      this.getCode() +
      new Date().getTime() +
      this.randomString(10) +
      this.getSuffix(name);
    formData.append('key', key);
    formData.append('name', name);
    formData.append('file', file);

    return send({
      url: this.uploadParam.host,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: false,
      data: formData,
      onProgress: (e) => onProgress(e, `${this.uploadParam.host}/${key}`),
    }).then((e) => {
      onSuccess(e, `${this.uploadParam.host}/${key}`);
    }, onError).catch(onError);
  },
};
export default ossUploader;
